import { axiosRequest, type AxiosResult } from "@/lib/axios";
import type { Tag, TagRequest, TagUpdateRequest, TagPaginatedResponse } from "@/modules/tag/types";

const API_BASE_URL = import.meta.env.VITE_SERVICE_CORE_URL;

export const tagApi = {
	index: async (workspaceId: string, cursor?: string | null, search?: string | null): Promise<AxiosResult<TagPaginatedResponse>> => {
		const params = new URLSearchParams();
		if (cursor) {
			params.set("cursor", cursor);
		}
		if (search) {
			params.set("filter[search]", search);
		}
		const queryString = params.toString();
		const url = `${API_BASE_URL}/${workspaceId}/tags${queryString ? `?${queryString}` : ""}`;
		const result = await axiosRequest<TagPaginatedResponse | Tag[]>({
			url,
			method: "GET",
			preserveFullResponse: true,
		});
		return result as AxiosResult<TagPaginatedResponse>;
	},

	create: async (workspaceId: string, payload: TagRequest) => {
		return await axiosRequest<Tag>({ url: `${API_BASE_URL}/${workspaceId}/tags`, method: "POST", data: payload });
	},

	update: async (id: string, workspaceId: string, payload: TagUpdateRequest) => {
		return await axiosRequest<Tag>({ url: `${API_BASE_URL}/${workspaceId}/tags/${id}`, method: "PATCH", data: payload });
	},

	delete: (id: string, workspaceId: string) => {
		return axiosRequest<void>({ url: `${API_BASE_URL}/${workspaceId}/tags/${id}`, method: "DELETE" });
	},

	getByIds: async (workspaceId: string, ids: string[]) => {
		return await axiosRequest<Tag[]>({ url: `${API_BASE_URL}/${workspaceId}/tags/by-ids`, method: "POST", data: { ids } });
	},
};
